// start:ng42.barrel
export * from './auth-guard';
// end:ng42.barrel

